import { render, staticRenderFns } from "./SignosVitales.vue?vue&type=template&id=ff3fb2d4&scoped=true"
import script from "./SignosVitales.vue?vue&type=script&lang=js"
export * from "./SignosVitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3fb2d4",
  null
  
)

export default component.exports